




































































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { db } from '@/main';
import * as firebase from 'firebase/app';
import uniqid from 'uniqid';
import Product from '@/interfaces/Product';
import Supplier from '@/interfaces/Supplier';
import ProductType from '@/interfaces/ProductType';
import User from '@/interfaces/User';
import ProductProperty from '@/components/ProductProperty.vue';
import { required, min_value as minValue } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('min_value', {
  ...minValue,
  message: '{_field_} should be at least {min}',
});

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    ProductProperty,
  },
})
export default class ProductDialog extends Vue {
  @Prop() private showDialog!: boolean;

  @Prop() private dialogMode!: string;

  @Prop() private suppliers!: Supplier[];

  @Prop() private productTypes!: ProductType[];

  @Prop() private productObject!: Product;

  currentUser: User;

  productDialogObject: Product;

  constructor() {
    super();
    this.currentUser = {} as User;
    this.productDialogObject = {} as Product;
  }

  @Watch('productObject')
  onProductObjectChanged(value: Product) {
    this.productDialogObject = value;
  }

  saveProduct(): void {
    (this.$refs.observer as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        this.closeDialog();
        this.productDialogObject.modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());

        if (this.dialogMode === 'add') {
          this.productDialogObject.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
          db.collection('products').add(this.productDialogObject);
        } else if (this.dialogMode === 'edit') {
          db.collection('products').doc(this.productDialogObject.id).set(this.productDialogObject);
        }
      });
  }

  changeManualPricing(changed: boolean) {
    if (changed) {
      this.productDialogObject.salePricePercentage = 0;
    } else {
      this.productDialogObject.salePrice = 0;
    }
  }

  setPricePercentage() {
    if (this.productDialogObject.salePricePercentage > 0
      && this.productDialogObject.pricePerItem > 0) {
      this.productDialogObject.salePrice = this.productDialogObject.pricePerItem
        + (this.productDialogObject.pricePerItem
        * (this.productDialogObject.salePricePercentage / 100));
    }
  }

  productTypeChange(): void {
    const getProductType = this.productTypes.filter((x) => x.id
      === this.productDialogObject.productTypeId)[0];
    if (getProductType) {
      this.productDialogObject.properties = getProductType.properties;
    } else {
      this.productDialogObject.properties = [];
    }
  }

  generateRandomCode(): void {
    this.productDialogObject.productCode = uniqid();
  }

  closeDialog() {
    this.$emit('update:showDialog', false);
  }
}
